module.exports = __webpack_public_path__ + "img/地图D-亚拉谷热气球.770a091c.png";